import { projectName } from '@/utils/config';

export default [
  {
    path: '/IFPageOneHThirtyResult',
    name: 'PageOneHThirtyResult',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHThirty/result.vue'),
  },
  {
    path: '/IFPageOneHThirtyLoading',
    name: 'pageOneHThirtyLoading',
    component: () => import('@/pages/pageListAll/pageOneHThirty/loading.vue'),
    meta: {
      title: projectName,
    },
  },
  {
    path: '/IFPageOneHThirtyGuide',
    name: 'PageOneHThirtyGuide',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHThirty/guide.vue'),
  },
];
